import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../Service/ApiService";
import "./Nav.css";
import Drawer from "../Drawer/Drawer";
import UpMenu from "../Upmenu/Upmenu";
import { AsyncImage } from "loadable-image";
import MobileUpMenu from "../MobileUpMenu/MobileUpMenu";
import projectData from "../../data/projects.json";
import buildingsData from "../../data/buildings.json";
import newsData from "../../data/news.json";
import jobData from "../../data/staff.json";

const Nav = ({ isAlbanian, toggleLanguage }) => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [catalogs, setCatalogs] = useState([]);
  const [news, setNews] = useState([]);
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    if (projectData && projectData.length > 0) {
    const shuffledProjects = [...projectData]
      .sort(() => 0.5 - Math.random());
    setProjects(shuffledProjects);
  }

    if (buildingsData && buildingsData.length > 0) {
    const shuffledBuildings = [...buildingsData]
      .sort(() => 0.5 - Math.random());
    setCatalogs(shuffledBuildings);
  }

    if (newsData && newsData.length > 0) {
    const shuffledNews = [...newsData]
      .sort(() => 0.5 - Math.random());
    setNews(shuffledNews);
  }

    if (jobData && jobData.length > 0) {
    const shuffledJobs = [...jobData]
      .sort(() => 0.5 - Math.random());
    setJobs(shuffledJobs);
  }

  }, []);

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
    setIsMenuOpen(false);
    setIsMobileMenuOpen(false);
  };

  const toggleMenu = () => {
    if (isMobile) {
      setIsMobileMenuOpen((prev) => !prev);
      setIsMenuOpen(false);
    } else {
      setIsMenuOpen((prev) => !prev);
      setIsMobileMenuOpen(false);
    }
    setIsDrawerOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMouseEnter = (menu) => setActiveMenu(menu);
  const handleMouseLeave = () => setActiveMenu(null);

  const truncateText = (text, maxLength) =>
    text.length > maxLength ? text.substring(0, maxLength) + "... →" : text;

  useEffect(() => {
    let lastScroll = 0;
    const handleScroll = () => {
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;
      const nav = document.querySelector(".nav");

      if (currentScroll > lastScroll && currentScroll > 110) {
        nav.style.top = "-110px";
      } else if (currentScroll < lastScroll) {
        nav.style.top = "0";
      }

      if (currentScroll > 0) {
        setIsScrolled(true);
        nav.classList.add("scrolled");
      } else {
        setIsScrolled(false);
        nav.classList.remove("scrolled");
      }

      lastScroll = currentScroll <= 0 ? 0 : currentScroll;
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

 
  const jobImages = {
    1: "/coneng.jpg",
    2: "/conwork.jpg",
    3: "/masterbuilder.jpg",
  };

  return (
    <>
      <nav className="nav">
        <div className="nav-logo-space">
          <img
            src={isScrolled ? "/vilallogonavred.png" : "/vilallogonav.png"}
            alt="logo-nav"
            className="nav-logo"
            onClick={() => navigate("/")}
          />
        </div>
        <div className="nav-buttons">
          <div
            className="nav-item"
            onMouseEnter={() => handleMouseEnter("ourCompany")}
            onMouseLeave={handleMouseLeave}
          >
            <a
              href="/?targetId=aboutUs"
              onClick={(e) => {
                e.preventDefault();
                navigate("/?targetId=aboutUs");
              }}
            >
              <button>{isAlbanian ? "Kompania jonë" : "Our Company"}</button>
            </a>

            {activeMenu === "ourCompany" && (
              <div className="submenu">
                <div className="submenu-holder">
                  <div className="submenu-left">
                    <h1>{isAlbanian ? "Rreth Nesh" : "About Us"}</h1>
                    <h2>
                      {(isAlbanian
                        ? `Vila-L Group është një kompani udhëheqëse ndërtimi me bazë në Tiranë, Shqipëri, me mbi 20 vite përvojë në sektorin e ndërtimeve rezidenciale dhe komerciale.\n
    Kompania është e njohur gjerësisht për ekzekutimin e projekteve në shkallë të gjerë dhe komplekseve rezidenciale, duke përdorur materialet dhe teknikat më të mira ndërtimore në vend, si dhe për integritetin dhe vlerat që përfaqëson.\n
    Ekipi i Vila-L është profesionalisht i trajnuar dhe siguron përfundimin e të gjitha fazave të një projekti, nga dizajni arkitektonik dhe inxhinierik deri te zbatimi i tij.`
                        : `Vila-L Group is a leading construction company based in Tirana, Albania, with over 20 years of experience in the residential and commercial building sector.\n
    The company is widely recognized for executing large-scale projects and residential complexes, utilizing the best construction materials and techniques in the country, as well as for the integrity and values it represents.\n
    The Vila-L team is professionally trained and ensures the completion of all phases of a project, from architectural and engineering design to its implementation.`
                      )
                        .split("\n")
                        .map((text, index) => (
                          <span key={index}>
                            {text}
                            <br />
                          </span>
                        ))}
                    </h2>
                  </div>
                  <div className="submenu-center">
                    <div className="submenu-center-first">
                      <h1>{isAlbanian ? "Kush jemi" : "Who we are"}</h1>
                      <ul>
                        <li>
                          <a
                            href="/?targetId=aboutUs"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/?targetId=aboutUs");
                              setActiveMenu(null);
                            }}
                          >
                            {isAlbanian ? "Rreth Nesh" : "About Us"}
                          </a>
                        </li>
                        <li>
                          <a
                            href="/?targetId=ourCulture"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/?targetId=ourCulture");
                              setActiveMenu(null);
                            }}
                          >
                            {isAlbanian ? "Vizioni Ynë" : "Our Vision"}
                          </a>
                        </li>
                        <li>
                          <a
                            href="/?targetId=ourHistory"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/?targetId=ourHistory");
                              setActiveMenu(null);
                            }}
                          >
                            {isAlbanian ? "Historia Jonë" : "Our History"}
                          </a>
                        </li>
                        <li>
                          <a
                            href="/?targetId=ourTeam"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/?targetId=ourTeam");
                              setActiveMenu(null);
                            }}
                          >
                            {isAlbanian ? "Ekipi Ynë" : "Our Team"}
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="submenu-center-vision-project">
                      <div className="vision-project-item">
                        <a
                          href="/?targetId=ourCulture"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/?targetId=ourCulture");
                            setActiveMenu(null);
                          }}
                        >
                          <AsyncImage
                            src="/vision.jpg"
                            alt="ourvision-photo"
                            className="ourvision-image-submenu-center-project"
                          />
                          <div className="vision-project-item-width">
                            <h2>
                              {isAlbanian
                                ? "Reputacioni i Vila-L gjatë viteve ka vendosur standarde të larta që do të udhëheqin... →"
                                : "The reputation that Vila-L has built over the years has set high standards that will guide.. →"}
                            </h2>
                          </div>
                        </a>
                        <div className="space-above-vision"></div>
                      </div>

                      <div className="vision-project-item">
                        <a
                          href="/?targetId=ourHistory"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/?targetId=ourHistory");
                            setActiveMenu(null);
                          }}
                        >
                          <AsyncImage
                            src="/history.jpg"
                            alt="ourvision-photo"
                            className="ourvision-image-submenu-center-project"
                          />
                          <div className="vision-project-item-width">
                            <h2>
                              {isAlbanian
                                ? "Historia e Vila-L filloi me themelimin e saj në vitin 2002 nga Z. Lazër Mhilli... →"
                                : "The history of Vila-L began with its establishment in 2002 by Mr. Lazër Mhilli... →"}
                            </h2>
                          </div>
                        </a>
                        <div className="space-above-vision"></div>
                      </div>

                      <div className="vision-project-item">
                        <a
                          href="/?targetId=ourTeam"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/?targetId=ourTeam");
                            setActiveMenu(null);
                          }}
                        >
                          <AsyncImage
                            src="/2.jpg"
                            alt="ourvision-photo"
                            className="ourvision-image-submenu-center-project"
                          />
                          <div className="vision-project-item-width">
                            <h2>
                              {isAlbanian
                                ? "Ekipi ynë përbëhet nga një staf i gjerë, nga specialistë me përvojë deri... →"
                                : "Our team consists of a broad staff, ranging from experienced specialists... →"}
                            </h2>
                          </div>
                        </a>
                        <div className="space-above-vision"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            className="nav-item"
            onMouseEnter={() => handleMouseEnter("ourProjects")}
            onMouseLeave={handleMouseLeave}
          >
            <a
              href="/ourcompany?targetId=projects"
              onClick={(e) => {
                e.preventDefault();
                navigate("/ourcompany?targetId=projects");
              }}
            >
              <button>{isAlbanian ? "Projektet" : "Our Projects"}</button>
            </a>

            {activeMenu === "ourProjects" && (
              <div className="submenu">
                <div className="submenu-holder">
                  <div className="submenu-left">
                    <h1>{isAlbanian ? "Projektet" : "Our Projects"}</h1>
                    <h2>
                      {(isAlbanian
                        ? `Projektet tona janë kryesisht të fokusuara në ndërtimin e objekteve rezidenciale, me realizime të suksesshme në zonat e Astirit, Freskut dhe Rrugës “5 Maji” në Tiranë, si dhe jashtë Shqipërisë, në Malin e Zi.\n
    Përveç projekteve rezidenciale, kemi zhvilluar edhe projekte komerciale, duke përfshirë një hotel në zonën e Don Boskos dhe një bujtinë në Iballe, Pukë.\n
    Aktualisht, jemi duke ndërtuar në zonën e Alliasit, pranë shkollës “Bajram Curri”, si dhe në Institut, Kamëz, pranë Universitetit Bujqësor të Tiranës.`
                        : `Our projects are primarily focused on the construction of residential buildings, with successful developments in areas such as Astir, Fresku, and “5 Maji” Street in Tirana, as well as internationally in Montenegro.\n
    In addition to residential projects, we have also undertaken commercial developments, including a hotel in the Don Bosko area and a guesthouse in Iballe, Pukë.\n
    Currently, we are constructing new projects in the Allias area, near "Bajram Curri" school, as well as in Institut, Kamëz, near the Agricultural University of Tirana.`
                      )
                        .split("\n")
                        .map((text, index) => (
                          <span key={index}>
                            {text}
                            <br />
                          </span>
                        ))}
                    </h2>
                  </div>
                  <div className="submenu-center">
                    <div className="submenu-center-first">
                      <h1>{isAlbanian ? "Projektet" : "Projects"}</h1>
                      <ul>
                        {projects.slice(0, 5).map((project) => (
                          <li key={project.project_id}>
                            <a
                              href={`/vilalproject/${project.project_id}`}
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/vilalproject/${project.project_id}`);
                                setActiveMenu(null);
                              }}
                            >
                              {isAlbanian
                                ? project.titulli_projekti
                                : project.project_title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="submenu-center-vision-project">
                      {projects
                        .slice(
                          0,
                          window.innerWidth >= 3899
                            ? 5
                            : window.innerWidth >= 3199
                            ? 4
                            : 3
                        )
                        .map((project) => (
                          <a
                            key={project.project_id}
                            href={`/vilalproject/${project.project_id}`}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`/vilalproject/${project.project_id}`);
                              setActiveMenu(null);
                            }}
                            className="vision-project-link"
                          >
                            <div className="vision-project-item">
                              <AsyncImage
                                src={project.project_image_url}
                                alt={project.project_title}
                                className="ourvision-image-submenu-center-project"
                              />
                              <div className="vision-project-item-width">
                                <h2>
                                  {isAlbanian
                                    ? project.titulli_projekti
                                    : project.project_title}
                                </h2>
                              </div>
                              <div className="space-above-vision"></div>
                            </div>
                          </a>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            className="nav-item"
            onMouseEnter={() => handleMouseEnter("ourSales")}
            onMouseLeave={handleMouseLeave}
          >
            <a
              href="/salescatalog?targetId=firstSalesRow"
              onClick={(e) => {
                e.preventDefault();
                navigate("/salescatalog?targetId=firstSalesRow");
              }}
            >
              <button>
                {isAlbanian ? "Katalogu i shitjeve" : "Sales catalog"}
              </button>
            </a>

            {activeMenu === "ourSales" && (
              <div className="submenu">
                <div className="submenu-holder">
                  <div className="submenu-left">
                    <h1>
                      {isAlbanian
                        ? "Katalogu jonë i shitjeve"
                        : "Our sales catalog"}
                    </h1>
                    <h2>
                      {isAlbanian
                        ? "Në katalogun e shitjes përfshihen apartamentet, njësitë e shërbimit, garazhet dhe ambiente të tjera të ofruara për shitje nga kompania jonë."
                        : "The sales catalog includes apartments, commercial units, garages, and other spaces available for sale by our company."}
                    </h2>
                  </div>
                  <div className="submenu-center">
                    <div className="submenu-center-first">
                      <h1>{isAlbanian ? "Kataloget" : "Catalogs"}</h1>
                      <ul>
                        {catalogs.slice(0, 5).map((catalog) => (
                          <li key={catalog.building_id}>
                            <a
                              href={`/secondstep/${catalog.building_id}`}
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/secondstep/${catalog.building_id}`);
                                setActiveMenu(null);
                              }}
                            >
                              {isAlbanian
                                ? catalog.titulli_nderteses
                                : catalog.building_title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="submenu-center-vision-project">
                      {catalogs
                        .slice(
                          0,
                          window.innerWidth >= 3899
                            ? 5
                            : window.innerWidth >= 3199
                            ? 4
                            : 3
                        )
                        .map((catalog) => (
                          <a
                            key={catalog.building_id}
                            href={`/secondstep/${catalog.building_id}`}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`/secondstep/${catalog.building_id}`);
                              setActiveMenu(null);
                            }}
                            className="vision-project-link"
                          >
                            <div className="vision-project-item">
                              <AsyncImage
                                src={catalog.building_image_url}
                                alt={catalog.catalog_title}
                                className="ourvision-image-submenu-center-project"
                              />
                              <div className="vision-project-item-width">
                                <h2>
                                  {isAlbanian
                                    ? catalog.titulli_nderteses
                                    : catalog.building_title}
                                </h2>
                              </div>
                              <div className="space-above-vision"></div>
                            </div>
                          </a>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            className="nav-item"
            onMouseEnter={() => handleMouseEnter("ourNews")}
            onMouseLeave={handleMouseLeave}
          >
            <a
              href="/news?targetId=newsSection"
              onClick={(e) => {
                e.preventDefault();
                navigate("/news?targetId=newsSection");
              }}
            >
              <button>{isAlbanian ? "Lajme" : "News & Insight"}</button>
            </a>

            {activeMenu === "ourNews" && (
              <div className="submenu">
                <div className="submenu-holder">
                  <div className="submenu-left">
                    <h1>{isAlbanian ? "Lajme" : "News & Insight"}</h1>
                    <h2>
                      {isAlbanian
                        ? "Lajmet dhe eventet nga Vila-L Group."
                        : "News and events from Vila-L Group."}
                    </h2>
                  </div>
                  <div className="submenu-center">
                    <div className="submenu-center-first">
                      <h1>{isAlbanian ? "Lajmet" : "News"}</h1>
                      <ul>
                        {news.slice(0, 3).map((news) => (
                          <li
                            key={news.news_id}
                            onClick={() => {
                              navigate(`/newsdetails/${news.news_id}`);
                              setActiveMenu(null);
                            }}
                          >
                            <a
                              href={`/newsdetails/${news.news_id}`}
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/newsdetails/${news.news_id}`);
                                setActiveMenu(null);
                              }}
                            >
                              {isAlbanian ? news.titull_lajmesh : news.news_title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="submenu-center-vision-project">
                      {news
                        .slice(
                          0,
                          window.innerWidth >= 3899
                            ? 5
                            : window.innerWidth >= 3199
                            ? 4
                            : 3
                        )
                        .map((news) => (
                          <a
                            key={news.news_id}
                            href={`/newsdetails/${news.news_id}`}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`/newsdetails/${news.news_id}`);
                              setActiveMenu(null);
                            }}
                            className="vision-project-link"
                          >
                            <div
                              key={news.news_id}
                              className="vision-project-item"
                              onClick={() => {
                                navigate(`/newsdetails/${news.news_id}`);
                                setActiveMenu(null);
                              }}
                            >
                              <AsyncImage
                                src={news.news_image_url}
                                alt={news.news_title}
                                className="ourvision-image-submenu-center-project"
                              />
                              <div className="vision-project-item-width">
                                <h2>
                                  {isAlbanian
                                    ? news.titull_lajmesh
                                    : news.news_title}
                                </h2>
                              </div>
                              <div className="space-above-vision"></div>
                            </div>
                          </a>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            className="nav-item"
            onMouseEnter={() => handleMouseEnter("ourCareer")}
            onMouseLeave={handleMouseLeave}
          >
            <a
              href="/staff?targetId=meet"
              onClick={(e) => {
                e.preventDefault();
                navigate("/staff?targetId=meet");
              }}
            >
              <button>{isAlbanian ? "Karriera" : "Career"}</button>
            </a>

            {activeMenu === "ourCareer" && (
              <div className="submenu">
                <div className="submenu-holder">
                  <div className="submenu-left">
                    <h1>{isAlbanian ? "Karriera" : "Career"}</h1>
                    <h2>
                      {isAlbanian
                        ? "Te Vila-L Group, ne ofrojmë mundësi në industrinë e ndërtimit. Pavarësisht nëse jeni i ri apo me përvojë, ne ju sigurojmë mjetet dhe mbështetjen e nevojshme për rritjen tuaj profesionale."
                        : "At Vila-L Group we offer exciting opportunities in the construction industry. Whether you're new or experienced, we provide the tools and support for career growth."}
                    </h2>
                  </div>
                  <div className="submenu-center">
                    <div className="submenu-center-first">
                      <h1>{isAlbanian ? "Vendet vakante" : "Job positions"}</h1>
                      <ul>
                        {jobs.slice(0, 5).map((job) => (
                          <li key={job.staff_id}>
                            <a
                              href={`/jobdetails/${job.staff_id}`}
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/jobdetails/${job.staff_id}`);
                                setActiveMenu(null);
                              }}
                            >
                              {isAlbanian ? job.titulli_staf : job.staff_title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="submenu-center-vision-project">
                      {jobs
                        .slice(
                          0,
                          window.innerWidth >= 3899
                            ? 5
                            : window.innerWidth >= 3199
                            ? 4
                            : 3
                        )
                        .map((job) => (
                          <a
                            key={job.staff_id}
                            href={`/jobdetails/${job.staff_id}`}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`/jobdetails/${job.staff_id}`);
                              setActiveMenu(null);
                            }}
                            className="vision-project-link"
                          >
                            <div className="vision-project-item">
                              <AsyncImage
                                src={
                                  jobImages[job.staff_id] ||
                                  "/images/default-job.jpg"
                                } 
                                alt={
                                  isAlbanian ? job.titulli_staf : job.staff_title
                                }
                                className="ourvision-image-submenu-center-project"
                              />
                              <div className="vision-project-item-width">
                                <h2>
                                {truncateText(
                            isAlbanian
                              ? job.pershkrimi_staf_dy
                              : job.staff_description_two,
                            75
                          )}
                                </h2>
                              </div>
                              <div className="space-above-vision"></div>
                            </div>
                          </a>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            className="hamburger-menu"
            onMouseEnter={() => setActiveMenu("hamburger")}
            onMouseLeave={() => setActiveMenu(null)}
            onClick={toggleMenu}
          >
            <div className="line"></div>
            <div className="linetwo"></div>
            <div className="linethree"></div>
          </div>
        </div>
        <div className="nav-third-part">
          <button onClick={toggleDrawer}>
            {isAlbanian ? "Kontakt" : "Contact us"}
          </button>
          <button onClick={toggleLanguage}>
            {isAlbanian ? "English" : "Shqip"}
            <img
              src={isAlbanian ? "/uk.png" : "/al.png"}
              className="flag-nav"
              alt="flag"
            />
          </button>
        </div>
      </nav>
      {isMobile && isMobileMenuOpen && (
        <MobileUpMenu
          isOpen={isMobileMenuOpen}
          onClose={toggleMenu}
          isAlbanian={isAlbanian}
          toggleLanguage={toggleLanguage}
        />
      )}
      <Drawer
        isOpen={isDrawerOpen}
        onClose={toggleDrawer}
        isAlbanian={isAlbanian}
      />
      <UpMenu
        isOpen={isMenuOpen}
        onClose={toggleMenu}
        isAlbanian={isAlbanian}
      />
    </>
  );
};

export default Nav;
